module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"location":"Location","eventDate":"Data evento"}}')
  delete Component.options._Ctor
}
